import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        const el = document.querySelector(href);
        el?.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative group w-full sm:w-auto ${className}`} data-id="element-127">
      <div className="absolute -inset-1 bg-cyan-accent/50 rounded-lg blur opacity-70 group-hover:opacity-100 transition duration-200" data-id="element-128"></div>
      <div className="relative flex items-center justify-center gap-2 bg-cyan-accent text-navy-900 font-display font-bold text-lg sm:text-xl px-8 py-4 rounded-lg shadow-[0_0_20px_rgba(0,212,255,0.3)] hover:shadow-[0_0_30px_rgba(0,212,255,0.5)] transition-all" data-id="element-129">
        {children}
        <ChevronRight className="w-6 h-6" data-id="element-130" />
      </div>
    </motion.button>;
}